module.exports = [{
      plugin: require('D:/Projekty/skates/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('D:/Projekty/skates/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-56499813-2","head":false,"anonymize":true,"respectDNT":true,"pageTransitionDelay":0},
    },{
      plugin: require('D:/Projekty/skates/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
